import axios from 'axios';
import ApiHelper from "@/helpsers/api.helper";
import AuthHelper from "@/helpsers/auth.helper";
import {useAuthStore} from "@/stores/auth.store";
import authHelper from "@/helpsers/auth.helper";
import StoreCache from "@/js/storeCache";

class UserService {

    static getUserInitials(clientData) {
        let initials = '';
        if(clientData.firstName && clientData.firstName.length > 0)
            initials += Array.from(clientData.firstName)[0];
        if(clientData.lastName && clientData.lastName.length > 0)
            initials += Array.from(clientData.lastName)[0];

        return initials;
    }

    getUserInfo() {
        const authStore = useAuthStore();
        authStore.isLoading = true;
        if (authStore.user) {
            axios.get(ApiHelper.getProfileUrl(), {headers: AuthHelper.authHeader()})
                .then(response => {
                    authStore.isLoading = false;
                    authStore.saveUserInfo(response.data);
                }).catch(error => {
                authStore.isLoading = false;
                //@TODO dorobić alert ze nie udało się pobrać danych i prosimy spróbować później.
            });
        }

    }

    setUserProfileImage(formData) {
        let result = null;
        const authStore = useAuthStore();
        const url = ApiHelper.getUploadProfileImageUrl();

        result = axios.post(url,formData,{
            headers: authHelper.authHeader()
        });

        return result.then(response => {
            authStore.userInfo.imagePath = response.data.imagePath + `?d=${new Date().getTime()}`;
        })
        .catch(e => {
            return Promise.reject('Error upload profile image',e);
        })
    }

    getUserProfileImage(photoId) {
        if(photoId> 0)
        return axios.get(ApiHelper.getUploadProfileImageUrl(parseInt(photoId)),{
            headers: authHelper.authHeader(),
            responseType: 'blob'
        })
            .then(result => {
                const objectURL = URL.createObjectURL(result.data);
                // authStore.userInfo.profilePhotoBlob = objectURL;
                return Promise.resolve(objectURL);
            })
            .catch(e => {
                return Promise.reject('Error get profile image');

            });
        else
            return Promise.reject('Error get profile image');
    }

    async removeUserProfileImage() {
        const authStore = useAuthStore();
        try {
            await axios.delete(ApiHelper.removeProfileImageUrl(), { headers: authHelper.authHeader() });
            authStore.userInfo.imagePath = null;
            return Promise.resolve('Success remove profile image');
        } catch (e) {
            return Promise.reject('Error remove profile image');
        }
    }

    /**
     * User logout
     */
    logout() {
        const authStore = useAuthStore();
        authStore.logout();
    }

    /**
     * Refresh token for user.
     */
    refreshToken() {
        axios.post(ApiHelper.getRefreshTokenUrl(),{},{
            headers: authHelper.authHeader()
        })
            .then(response => {
                try {
                    const user = StoreCache.get('user');
                    user.tokenExpirationTime = response.data.tokenExpirationTime;
                    user.accessToken = response.data.accessToken;
                    StoreCache.set('user', user);
                    return true;
                }
                catch (error) {
                    throw new Error('Error during refresh token. Error: '. error);
                }
            })
            .catch(error => {
                console.log("Error during refresh token. Error: ",error);
            })
    }

    async checkToken() {
        return await axios.get(ApiHelper.getCheckTokenUrl(),{
            headers: authHelper.authHeader()
        })
            .then(response => {
                if(!response.data)
                    this.logout();
            })
            .catch(error => {
                this.logout();
            })
    }

}

export default UserService;
